import React, { useEffect } from "react";
import Button from "../../components/Button/Button";
import { loginSchema } from "../../components/Campaign/Create/schema";
import { yupResolver } from "@hookform/resolvers/yup";
import { LoginFormValues } from "../../types/campaign/campaign.tpes";
import { useForm } from "react-hook-form";
import { useAuth } from "../../context/useAuth";
import LoadingState from "../../components/Loading/Loading";
import { useNavigate } from "react-router";

const AuthPage = () => {
  const [loading, setLoading] = React.useState(false);
  const { loginUser, isLoggedIn } = useAuth();
  const methods = useForm<LoginFormValues>({
    resolver: yupResolver(loginSchema),
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    control,
    reset,
    watch,
    register,
    setError,
    formState: { errors },
  } = methods;

  useEffect(() => {
    isLoggedIn() && navigate("/dashboard");
  }, [isLoggedIn, navigate]);

  const onSubmit = async (data: LoginFormValues) => {
    setLoading(true);
    await loginUser(data.username, data.password)
      .then((res: any) => {
        // navigate("/dashboard");
      })
      .catch((err: any) => {
        setError("password", { message: err });
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section className="bg-[#1C0C40] h-screen flex">
      {loading && <LoadingState />}
      <div className="w-1/2">
        <div className="flex flex-col justify-center items-center h-full space-y-5">
          <section>
            <img
              className="w-48 h-48"
              src="/logo/logomv.png"
              alt="meta image"
            />
          </section>
          <section>
            <img className="w-20" src="/logo/dlogo.png" alt="meta image" />
          </section>
          <section>
            <p className="text-white font-thin text-3xl">Futureverse</p>
          </section>
        </div>
      </div>
      <div className="flex flex-col w-1/2 bg-white items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
        <div className="w-full bg-white rounded-lg md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-black md:text-2xl text-center">
              Admin Login
            </h1>
            <form
              className="space-y-4 md:space-y-6"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div>
                <label
                  htmlFor="username"
                  className="block text-sm font-medium text-gray-500"
                >
                  Username
                </label>
                <input
                  type="username"
                  id="username"
                  className="h-8 bg-gray-50 shadow-md rounded-3xl border border-gray-300 text-gray-900 focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                  {...register("username")}
                />
                {errors.username && (
                  <span className="text-red-400">
                    {errors.username.message}
                  </span>
                )}
              </div>
              <div>
                <label
                  htmlFor="password"
                  className="block text-sm font-medium text-gray-500"
                >
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  placeholder=""
                  className="h-8 bg-gray-50 shadow-md rounded-3xl border border-gray-300 text-gray-900 focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5"
                  {...register("password")}
                />
                {errors.password && (
                  <span className="text-red-400">
                    {errors.password.message}
                  </span>
                )}
              </div>
              <div className="flex items-center justify-between">
                {/* <div className="flex items-start">
                  <div className="flex items-center h-5">
                    <input
                      id="remember"
                      aria-describedby="remember"
                      type="checkbox"
                      className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-primary-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-primary-600 dark:ring-offset-gray-800"
                    />
                  </div>
                  <div className="ml-3 text-sm">
                    <label
                      htmlFor="remember"
                      className="text-gray-500 dark:text-gray-300"
                    >
                      Remember me
                    </label>
                  </div>
                </div> */}
                {/* <a
                  href="#"
                  className="text-sm font-medium text-white hover:underline dark:text-primary-500 "
                >
                  Forgot password?
                </a> */}
              </div>
              <div className="flex justify-center">
                <button
                  type="submit"
                  className=" bg-[#1D1D1F] w-fit text-white px-5 py-1 rounded-2xl"
                >
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AuthPage;
